import React, { Component, FormEvent } from "react";
import {
  Card,
  Col,
  Container,
  FormControlProps,
  Modal,
  Row,
  Alert
} from "react-bootstrap";
import PropTypes from "prop-types";
import SearchForm from "../../components/SearchForm";
import * as backendAPI from "../../api/backendAPI";
import SearchResults from "../../components/SearchResults";
import queryString from "query-string";
import { Company } from "../../models/Company";
import { Invoice } from "../../models/Invoice";
// import {getDaysLeft} from "../../utils/utils";
// import {BadgeComponent} from "../../components/Badge";

import styles from "./PolicySearchPage.module.scss";
import { AccordionComponent } from "../../components/Accordion";

interface PolicySearchPageState {
  policyNumber: any | any;
  feinNumber: string | any;
  error: string;
  loading: boolean;
  showResult: boolean;
  isPolicyNumber: boolean;
  isFeinNumber: boolean;
  impersonationToken: string;
  showCompanySelection: boolean;
  showPolicySelection: boolean;
  showInvoicesSelection: boolean;
  companies?: Company[];
  invoices?: Invoice[];
  selectedCompany?: Company;
  selectedPolicy?: Company;
  selectedInvoice?: Invoice[];

}

class PolicySearchPage extends Component<{}, PolicySearchPageState> {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };

  state: PolicySearchPageState = {
    policyNumber: "",
    feinNumber: "",
    error: "",
    loading: false,
    showResult: false,
    isPolicyNumber: false,
    isFeinNumber: false,
    impersonationToken: "",
    showCompanySelection: false,
    showPolicySelection: false,
    showInvoicesSelection: false,
  };

  componentDidMount() {
    const params = queryString.parse(window.location.search);
    if (params.policyNumber) {
      this.setState(
        {
          policyNumber: params.policyNumber.toString(),
          isPolicyNumber: true,
        },
        (): void => {
          this.findCompany(this.state.policyNumber);
        }
      );
    }
  }

  componentWillUnmount() {
  }

  async findCompany(term: string) {
    await this.setState({
      loading: true,
      showResult: false,
      selectedCompany: undefined,
      selectedPolicy: undefined,
      companies: [],
      error: "",
    });
    try {
      const companies: Company[] = await backendAPI.getCompanyAndToken(term);

      // result.status === 200
      if (companies.length === 0) {
        this.setState({
          loading: false,
          showResult: true,
        });
      } else {
        this.setState({
          loading: false,
          companies: companies,
          showCompanySelection: true,
        });
      }
    } catch (e) {
      // todo: implement actual error handling
      this.setState({
        loading: false,
        error: "Something went wrong! Please try again later.",
      });
    }
  }

  onChange = (e: FormEvent<FormControlProps>): void => {
    if (e.currentTarget.id === "policyNumber") {
      this.setState(
        {
          policyNumber: e.currentTarget.value || "",
        },
        (): void => {
          if (this.state.policyNumber !== "") {
            this.setState({
              isPolicyNumber: true,
            });
          } else {
            this.setState({
              isPolicyNumber: false,
            });
          }
        }
      );
    } else {
      this.setState(
        {
          feinNumber: e.currentTarget.value || "",
        },
        (): void => {
          if (this.state.feinNumber !== "") {
            this.setState({
              isFeinNumber: true,
            });
          } else {
            this.setState({
              isFeinNumber: false,
            });
          }
        }
      );
    }
  };

  onSearchSubmit = (term: string): void => {
    this.findCompany(term);
  };

  handleSearchAgain = (): void => {
    this.setState({
      policyNumber: "",
      feinNumber: "",
      showResult: false,
    });

    const policyNumberField = document.getElementById("policyNumber");
    const finNumberField = document.getElementById("finNumber");

    if (policyNumberField && this.state.isPolicyNumber) {
      policyNumberField.focus();
      this.setState({
        isPolicyNumber: false,
      });
    } else if (finNumberField && this.state.isFeinNumber) {
      finNumberField.focus();
      this.setState({
        isFeinNumber: false,
      });
    }
  };

  cleanupModalBackdrop = (): void => {
  };

  handleCompanySelectionClose = (): void => {
    this.setState({
      showCompanySelection: false,
    });
  };

  handlePolicySelectionClose = (): void => {
    this.setState({
      showPolicySelection: false,
    });
  };

  handleInvoicesSelectionClose = (): void => {
    this.setState({
      showInvoicesSelection: false,
    });
  };



  handleshowResult = (): void => {
    this.setState({
      showInvoicesSelection: false,
      showResult: true,
    });

  };



    handleSelectInvoice = (invoiceOrArray: Invoice | Invoice[]): void => {

      // Bounced monthly reports come as families (parent + fee siblings) and
      // are toggled as a unit, so this handler accepts a batch and toggles
      // each member's presence atomically.
      const toToggle: Invoice[] = Array.isArray(invoiceOrArray) ? invoiceOrArray : [invoiceOrArray];

      let invoices: Invoice[] = this.state.selectedInvoice ? [...this.state.selectedInvoice] : [];

      for (const invoice of toToggle) {
        const existingIdx = invoices.findIndex(i => i.InvoiceNumber === invoice.InvoiceNumber);
        if (existingIdx >= 0) {
          invoices.splice(existingIdx, 1);
        } else {
          invoices.push(invoice);
        }
      }

      this.setState({
        selectedInvoice: invoices,
      },
        (): void => {
          console.log(this.state.selectedInvoice);
        }
      );


  }



  getUniqueCompanyNames() {
    const companies: string[] = [];
    if (!this.state.companies) {
      return companies;
    }
    this.state.companies.forEach((c: Company) => {
      if (!companies.includes(c.name)) {
        companies.push(c.name);
      }
    });
    return companies;
  }


  setSelectedCompany(name: string) {
    if (!this.state.companies) {
      return;
    }
    this.state.companies.forEach((c: Company) => {
      if (c.name === name) {
        this.setState({
          selectedCompany: c,
        });
      }
    });
  }


  getCompanySelectionCards(companies: string[]) {
    try {
      return companies.map((company: string) => {
        return (
          <div key={company} className={styles["company-select-card"]}>
            <a
              key={company}
              onClick={() => {
                this.setState({
                  showCompanySelection: false,
                  showPolicySelection: true,
                });
                this.setSelectedCompany(company);
              }
              }
            >
              <Card className={styles["company-card"]}>
                <Card.Body>
                  <Card.Title>{company}</Card.Title>
                </Card.Body>
              </Card>
            </a>
          </div>
        );
      });
    } catch (e) {
      this.setState({
        showCompanySelection: false,
        companies: undefined,
      });
    }
  }

  getCompanySelectionModal() {
    return (
      <Modal
        show={this.state.showCompanySelection}
        centered={true}
        onHide={this.handleCompanySelectionClose}
        backdrop="static"
      >
        <Modal.Header
          closeButton={true}
          style={{
            backgroundColor: "#1313b7",
            justifyContent: "center",
          }}
        >
          <Modal.Title className="font-weight-bold">Select Company</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {this.getCompanySelectionCards(this.getUniqueCompanyNames())}
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  getPolicySelectionCardsBySelectedCompanyName(policies: Company[]) {
    try {
      return policies.map((policy: Company, index: number) => {
        const uniqueKey = `${policy.policyNumber}_${policy.policyFrom}_${policy.policyTo}`;
        return (
          <div key={uniqueKey} className={styles["company-select-card"]}>
            <a
              key={uniqueKey}
              onClick={() =>
                this.setState({
                  selectedPolicy: policy,
                  showPolicySelection: false,
                  showInvoicesSelection: true,
                })
              }
            >
              <Card className={styles["company-card"]}>
                <Card.Body>
                  <Card.Title>{policy.policyNumber}</Card.Title>
                  <Card.Subtitle>
                    {`${policy.policyFrom} to ${policy.policyTo}`}
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </a>
          </div>
        );
      });
    } catch (e) {
      this.setState({
        showPolicySelection: false,
        companies: undefined,
      });
    }
  }






  getInvoicesSelectionCardsBySelectedCompanyName() {
    try {
      if (!this.state.selectedPolicy) {
        return null;
      }
      const invoices: Invoice[] = this.state.selectedPolicy.invoices || [];

      return (
        <AccordionComponent
          invoices={invoices}
          handleSelectInvoice={this.handleSelectInvoice}
          selectedInvoice={this.state.selectedInvoice}
          handleshowResult={this.handleshowResult} />
      )
    } catch (e) {
      this.setState({});
    }
  }

  getPoliciesForCompany(companyName: string): Company[] {
    if (!this.state.companies) {
      return [];
    }
    return this.state.companies.filter((c: Company) => c.name === companyName);
  }

  getPolicySelectionModal() {
    return (
      <Modal
        show={this.state.showPolicySelection}
        centered={true}
        onHide={this.handlePolicySelectionClose}
        backdrop="static"
      >
        <Modal.Header
          closeButton={true}
          style={{
            backgroundColor: "#1313b7",
            justifyContent: "center",
          }}
        >
          <Modal.Title className="font-weight-bold">Select Policy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {this.getPolicySelectionCardsBySelectedCompanyName(
              this.getPoliciesForCompany(this.state.selectedCompany?.name || "")
            )}
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  getInvoicesSelectionModal() {
    return (
      <Modal
        show={this.state.showInvoicesSelection}
        centered={true}
        onHide={this.handleInvoicesSelectionClose}
        backdrop="static"
      >
        <Modal.Header
          closeButton={true}
          style={{
            backgroundColor: "#1313b7",
            justifyContent: "center",
          }}
        >
          <Modal.Title className="font-weight-bold">Select Invoices</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {this.getInvoicesSelectionCardsBySelectedCompanyName()}

          </div>
        </Modal.Body>
      </Modal>
    );
  }

  render() {
    return (
      <Container>
        <Row className="justify-content-center">
          <Col md={6}>
            {this.state.error ? (
              <Alert variant="danger">
                {this.state.error}
              </Alert>
            ) : null}

            <SearchForm
              policyNumber={this.state.policyNumber}
              feinNumber={this.state.feinNumber}
              isPolicyNumber={this.state.isPolicyNumber}
              isFeinNumber={this.state.isFeinNumber}
              onSearchSubmit={this.onSearchSubmit}
              onChange={this.onChange}
              loading={this.state.loading}
            />
          </Col>

          {this.state.showResult ? (
            <Col md={6}>
              <SearchResults
                selectedPolicy={this.state.selectedPolicy?.policyNumber}
                selectedInvoice={this.state.selectedInvoice}
                selectedCompany={this.state.selectedPolicy}
                handleSearchAgain={this.handleSearchAgain}
              />
            </Col>
          ) : null}

          {this.getCompanySelectionModal()}
          {this.getPolicySelectionModal()}
          {this.getInvoicesSelectionModal()}
        </Row>
      </Container>
    );
  }
}

export default PolicySearchPage;
